/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { PRIMARY_OUTLET, Router, UrlSegment } from '@angular/router';
import { Cluster2xConnectionToken } from '@shared/types/cluster';

@Injectable({ providedIn: 'root' })
export class RouteConnectionToken {
  constructor(
    private router: Router,
    private location: Location,
  ) {}
  private canConsume() {
    const path = this.location.path();
    return !(path.startsWith(`/password/reset`) || path.startsWith(`/auth/reset`));
  }
  value(): Cluster2xConnectionToken | undefined {
    if (!this.canConsume()) return void 0;
    const tree = this.router.parseUrl(this.location.path());
    const segments: UrlSegment[] | undefined = tree.root.children[PRIMARY_OUTLET]?.segments;
    return segments?.length === 2 && segments[0]?.path === 'go' ? segments[1]?.path : tree.queryParams.token;
  }
  consumeToken(): void {
    if (!this.canConsume()) return;
    const tree = this.router.parseUrl(this.location.path());
    if (tree.queryParams.token) {
      this.router.navigate([], {
        queryParams: { token: null },
        queryParamsHandling: 'merge',
      });
    }
  }
}
